import React, { memo } from "react";

import "./style.scss";

function AvailabilityDot({ data = {} }) {
  return (
    <div className="availability-dot" type={data.type} title={data.name}>
      <i className="fas fa-circle" />
    </div>
  );
}

export default memo(AvailabilityDot);
